import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, tap } from 'rxjs';
import { SessionModel } from 'src/formio-custom-components/src/lib/shared/model';
import { CommonQuestionModel, QuestionSession } from '../../models';
import { FormDialogData, memberFormModel } from '../../models/dialog';
import { CommonQuestionsService } from '../../services';

@Component({
  selector: 'app-users-sessions-dialog',
  templateUrl: './users-sessions-dialog.component.html',
  styleUrls: ['./users-sessions-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsersSessionsDialogComponent implements OnInit {
  formGroup: FormGroup;
  sessions$: Observable<SessionModel[]>;

  mode: 'add' | 'edit';

  selectedSession: SessionModel[] = null;
  members: Record<string, memberFormModel> = {};

  get isMemberValid() {
    return Object.values(this.members).some((item) => !!item.members?.length);
  }

  constructor(
    public dialogRef: MatDialogRef<UsersSessionsDialogComponent, CommonQuestionModel>,
    @Inject(MAT_DIALOG_DATA) public data: FormDialogData,
    public questionsService: CommonQuestionsService
  ) {
    this.mode = this.data?.mode;
    this.sessions$ = this.questionsService
      .getSessionsByVisitKey(this.data?.visitKey)
      .pipe(
        tap((data) => {
          data.forEach((item) => {
            this.members[item.id] = {
              sessionId: item.id,
              members: this.members[item.id]?.members || [],
            };
          });
        })
      );
  }

  compareSessionWithFn = (o1: SessionModel, o2: SessionModel) => {
    return o1?.id === o2?.id;
  };

  ngOnInit(): void {
    if (this.mode == 'edit') {
      this.prepareSessions(this.data.question.sessions);
    }
  }
  prepareSessions(sessions: QuestionSession[]) {
    sessions?.forEach((session) => {
      this.members[session.sessionId] = {
        sessionId: session.sessionId,
        members: session.members.split(',').map((id) => Number(id)),
      };
    });
  }

  submit() {
    const sessions = this._prepareDataToSave();

    if (!!sessions?.length) {
      const data = Object.assign(this.data.question, { sessions: sessions });
      this.dialogRef.close(data);
    }
  }

  private _prepareDataToSave() {
    return Object.values(this.members).reduce((prev, curr) => {
      if (!curr.members?.length) {
        return prev;
      }
      return [
        ...prev,
        {
          sessionId: curr.sessionId,
          members: curr.members.join(),
        },
      ];
    }, []);
  }
}
